const TaskImages =
    {
        exploregrave: require('../assets/images/exploregrave2.png'),
		glass: require('../assets/images/glassa.png'),
        littlelich: require('../assets/images/little-lich.png'),
        lichbaby: require('../assets/images/lich-baby.png'),
        //lichbabybw: require('../assets/images/lich-baby-bw.png'),
		lichbabybw: require('../assets/images/new-baby.png'),
		lichkid: require('../assets/images/kidlich.png'),
		lichteen: require('../assets/images/teenlich.png'),
		lichadult: require('../assets/images/adultlich.png'),
		
		
        swiftness: require('../assets/images/swiftness2.png'),
		observation: require('../assets/images/observation.png'),
        brains: require('../assets/images/brains2.png'),
		
		necro: require('../assets/images/necro.png'),
		
		book: require('../assets/images/book.png'),
		
		wwskill: require('../assets/images/wwskill.png'),
		
		
        back: require('../assets/images/lbback.png'),
        phy: require('../assets/images/phy.png'),
        gravedigging: require('../assets/images/gravedigging.png'),
        mud: require('../assets/images/mud.png'),
        crowhunt: require('../assets/images/crowhunting.png'),
        evolve: require('../assets/images/evolve.png'),
		bearhunt: require('../assets/images/bearhunt.png'),
		gate: require('../assets/images/gate-6.png'),
		bones: require('../assets/images/bonea.png'),
		blood: require('../assets/images/blood2.png'),
		corpses: require('../assets/images/corpsea.png'),
		mana: require('../assets/images/mana.png'),
		/*
		minions: require('../assets/images/minions.png'),
		mount: require('../assets/images/mount.png'),
		potions: require('../assets/images/potions.png'),
		shrooms: require('../assets/images/shrooms.png'),
		spoils: require('../assets/images/spoils.png'),
		support: require('../assets/images/support.png'),
		supplies: require('../assets/images/supplies.png'),
		*/
		minions: require('../assets/images/minionsa.png'),
		mount: require('../assets/images/mounta.png'),
		potions: require('../assets/images/potionsa.png'),
		shrooms: require('../assets/images/shroomsa.png'),
		spoils: require('../assets/images/spoilsa.png'),
		support: require('../assets/images/supporta.png'),
		supplies: require('../assets/images/suppliesa.png'),
		
		
		arrow: require('../assets/images/arrow2.png'),
		backarrow: require('../assets/images/backarrow2.png'),
		//bonea: require('../assets/images/bonea.png'),
		
		crawling: require('../assets/images/crawlingicon2.png'),
		observecrows: require('../assets/images/observecrows.png'),
		lowerthreat: require('../assets/images/dove.png'),
		evolvekid: require('../assets/images/kidlich2.png'),
		forestsearch: require('../assets/images/forestsearch.png'),
		swampglass: require('../assets/images/swampglass.png'),
		evolveteen: require('../assets/images/evolveteen.png'),
		tourschool: require('../assets/images/tourschool.png'),
		'class': require('../assets/images/class.png'),
		ww: require('../assets/images/ww.png'),
		ee: require('../assets/images/ee.png'),
		pp: require('../assets/images/pp.png'),
		aa: require('../assets/images/aa.png'),
		lan: require('../assets/images/lan.png'),
		
		evolveadult: require('../assets/images/evolveadult.png'),
		magic: require('../assets/images/manaa.png'),
		
		wander: require('../assets/images/wander.png'),
		crun: require('../assets/images/crun.png'),
		drill: require('../assets/images/drill.png'),
		shand: require('../assets/images/shand.png'),
		
		dockfish: require('../assets/images/dockfish.png'),
		
		crowslog: require('../assets/images/crowslog.png'),
		forest: require('../assets/images/forest.png'),
		swamp: require('../assets/images/dredginglog.png'),
		school: require('../assets/images/school.png'),
		
		weedclub: require('../assets/images/weedclub.png'),
		planarclub: require('../assets/images/planarclub.png'),
		debateclub: require('../assets/images/debateclub.png'),
		aaclub: require('../assets/images/aaclub.png'),
		lanclub: require('../assets/images/lanclub.png'),
		
		town: require('../assets/images/town.png'),
		
		slums: require('../assets/images/slums.png'),
		docks: require('../assets/images/docks.png'),
		tavern: require('../assets/images/tavern.png'),
		pits: require('../assets/images/pits.png'),
		
		towntriangle: require('../assets/images/towntriangle.png'),
		market: require('../assets/images/market.png'),
		apoth: require('../assets/images/apoth.png'),
		cartel: require('../assets/images/cartel.png'),
		
		manor: require('../assets/images/manors.png'),
		barracks: require('../assets/images/barracks.png'),
		wizard: require('../assets/images/wizard.png'),
		theater: require('../assets/images/theater.png'),
		
		pillaged: require('../assets/images/pillaged.png'),
    };

export default TaskImages;